export default __webpack_public_path__ + "static/media/back-arrow.dd22f6a7.svg";